import { ChangeEventHandler, JSX } from "react";
import { FormProps } from "./FormProps";
interface TextareaProps extends FormProps {
  onChange?: ChangeEventHandler<HTMLTextAreaElement> | undefined
}
export default function Textarea({
  label,
  name,
  id,
  rows,
  cols,
  value,
  onChange,
  placeholder,
  className,
  ...Props
}: TextareaProps): JSX.Element {
  return (
    <div className="">
      <label className="block text-sm/6 font-medium text-left">{label}</label>
      <textarea
        placeholder={`Add ${label?.toLowerCase()}...`}
        id={id}
        className={`w-full grow p-2 text-wrap truncate border-[1px] text-base placeholder:text-gray-400 sm:text-sm/6 border-primary-900 shadow-sm border-opacity-50 rounded-lg [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ${className}`}
        name={name}
        value={value === null || value === 0 ? "" : value}
        rows={rows}
        cols={cols}
        onChange={onChange}
        {...Props}
      ></textarea>
    </div>
  );
}
